var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"pagination"}},[_c('sliding-pagination',{attrs:{"current":_vm.currentPage,"total":_vm.totalPages},on:{"page-change":_vm.pageChangeHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }